<template>
  <div class="library__view">
    <h1 class="library__title">Icons</h1>

    <section id="search" class="library__section">
      <b-row>
        <b-col>
          <b-form-group label="Ricerca" label-class="vb-label">
            <vb-input
              v-model="search_icon"
              :vb_options="{
                autocomplete: 'chrome-off',
              }"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </section>

    <section class="library__section">
      <p class="library__section-title d-flex justify-content-between">
        Design icons

        <vb-checkbox
          class="text--base"
          @change="toggle_dotted"
          :vb_options="{
            text: 'Mostra versione dotted',
            switch: true,
            type: 'light',
          }"
        />
      </p>

      <b-row v-if="Object.keys(DesignIcons).length > 0">
        <b-col
          md="1"
          v-for="(icon, icon_index) in Object.keys(DesignIcons).sort()"
          v-bind:key="icon_index"
        >
          <div
            class="mb-4 pt-4 d-flex align-items-center flex-column justify-content-center"
          >
            <small v-if="search_icon" class="mb-2">
              <span
                v-for="(item, index) in icon
                  .split(search_icon)
                  .flatMap((part, index) =>
                    index > 0 ? [search_icon, part] : [part]
                  )"
                :key="`${icon}:${item}:${index}`"
                :class="item === search_icon ? 'library__section--underlined' : ''"
                >{{ item }}</span
              >
            </small>
            <small v-else class="mb-2">
              {{ icon }}
            </small>
            <vb-icon
              :name="icon"
              :color="show_dotted ? '000' : '999'"
              :dotted="show_dotted"
            />
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          Nessuna corrispondenza da mostrare
        </b-col>
      </b-row>
    </section>

    <section class="library__section">
      <p class="library__section-title">Custom icons</p>

      <b-row  v-if="Object.keys(CustomIcons).length > 0">
        <b-col
          md="1"
          v-for="(icon, icon_index) in Object.keys(CustomIcons).sort()"
          v-bind:key="icon_index"
        >
          <div
            class="mb-4 pt-4 d-flex align-items-center flex-column justify-content-center"
          >
            <small v-if="search_icon" class="mb-2">
              <span
                v-for="(item, index) in icon
                  .split(search_icon)
                  .flatMap((part, index) =>
                    index > 0 ? [search_icon, part] : [part]
                  )"
                :key="`${icon}:${item}:${index}`"
                :class="item === search_icon ? 'library__section--underlined' : ''"
                >{{ item }}</span
              >
            </small>
            <small v-else class="mb-2">
              {{ icon }}
            </small>
            <vb-icon :name="icon" />
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          Nessuna corrispondenza da mostrare
        </b-col>
      </b-row>
    </section>

</div>
</template>

<script>
import * as DesignIcons from "@/components/svg/design-icons";
import * as CustomIcons from "@/components/svg/custom-icons";

export default {
  name: "icons",
  data() {
    return {
      show_dotted: false,
      search_icon: "",
    };
  },
  computed: {
    DesignIcons() {
      return this.filter_by_search(DesignIcons, this.search_icon);
    },
    CustomIcons() {
      return this.filter_by_search(CustomIcons, this.search_icon);
    },
  },
  methods: {
    toggle_dotted() {
      this.show_dotted = !this.show_dotted;
    },
    filter_by_search(icons, search = "") {
      return search
        ? Object.fromEntries(
            Object.entries(icons).filter((entry) => entry[0].includes(search))
          )
        : icons;
    },
  },
};
</script>

<style lang="scss" scoped>
.library__section {
  &--underlined {
    font-weight: bold;
    text-decoration: underline;
    text-decoration-thickness: 3px;
  }
}
</style>
